import React, { useState } from 'react'
import {
    Card, H5, H6, Divider, Row, Col, Tabs, Tab, FormikInput, FormikSimpleSelect,
    CancelButton, SaveButton, Form, DailyBatchesProNav, FormikDate,
} from '../../Elements'
import { Icon, NonIdealState } from '@blueprintjs/core'
import { isEqualWith } from 'lodash'
import { Prompt } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { ColorAdditionsRow, CrewInformationRow } from '../Job/JobForm/SharedPebbleForms'
import { AddressLinkText } from "../../Elements/Address";
import moment from "moment"

const iconStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px'
}
const vTabStyle = {
    whiteSpace: 'normal',
    width: '120px',
    minHeight: '50px',
    lineHeight: '20px',
    marginBottom: '10px',
    border: '1px solid'
}

const thirdWidthStyle = {
    maxWidth: '20%',
    display: 'inline-block',
    margin: '5%',
    marginTop: '0'
}

const _getJobTypeNames = (job_types) => {
    let names = job_types && job_types.map(j => j.name).join(', ')
    return names ? names : 'No Job Types'
}

const _getTabTitle = (sub_job) => {
    if (sub_job && sub_job.job_category) {
        let date = sub_job.job_category.id === 2 && sub_job.pebble_details.app_date

        return <span>
            {<p>{_getJobTypeNames(sub_job.job_types)}</p>}
            {date ? <p>{date}</p> : <p>No Date</p>}
        </span>
    }
}

export const DailyBatchesForm = ({ values, onCancel, jobStatuses, pebbleColorMaterialTypes, crewTypes, pebbleColors, pebbleColorAdditives,
    poolSections, employees, setFieldValue, pebblePhases, jobOrders, slurryPickupOptions, ...props }) => {
    const indexOfFirstPebbleSubjob = values.sub_jobs && values.sub_jobs.indexOf(values.sub_jobs.find(sj => sj.job_category && sj.job_category.id === 2))
    const DEFAULT_SUB_TAB = `sub_jobs-${indexOfFirstPebbleSubjob}`

    const [tabState, setTabState] = useState(DEFAULT_SUB_TAB)
    const [sidebarVisible, setSidebarState] = useState(true)
    const colStyle = !sidebarVisible ? { display: 'none' } : {}
    const isMobile = useMediaQuery({ query: '(max-width: 800px)' })

    return <Form>
        <Prompt
            when={!props.isSubmitting && !isEqualWith(values, props.initialValues, (newValue, oldValue, key) => {
                if (!newValue && !oldValue) return true
            })}
            message={'You have unsaved changes. Navigate away?'}
        />
        <Row>
            <Col lg={12}>
                <Card>
                    <span style={{ 'float': 'right' }}>
                        <CancelButton isMobile={isMobile} onClick={onCancel} />
                        <SaveButton style={{ float: 'right' }} isMobile={isMobile} />
                        <DailyBatchesProNav />
                    </span>
                    <H5>{values.company.company_name} - {values.name}</H5>
                    <H6>Order Id: {values.id}</H6>
                    <AddressLinkText
                        line1={values.address_line_1}
                        line2={values.address_line_2}
                        city={values.city}
                        state={values.state}
                        zip={values.zip_code}
                    />
                </Card>
            </Col>
        </Row>
        <Divider />
        {indexOfFirstPebbleSubjob === -1
            ? <NonIdealState
                icon='issue'
                title='This job does not contain any Pebble Records'
            />
            : <Card>
                <Row>
                    {!sidebarVisible && <Icon
                        icon='caret-right'
                        iconSize='20'
                        onClick={() => setSidebarState(true)}
                    />
                    }
                    <Col lg={1} style={colStyle}>
                        <div style={iconStyle}>
                            <Icon icon='caret-left' iconSize='20'
                                onClick={() => setSidebarState(false)} />
                        </div>
                        <Tabs
                            id="job_detail_tab"
                            onChange={setTabState}
                            selectedTabId={tabState}
                            style={vTabStyle}
                            vertical
                        >
                            {values.sub_jobs && values.sub_jobs.map((sub_job, idx) => {
                                return sub_job.job_category && sub_job.job_category.id === 2 && (
                                    <Tab
                                        style={vTabStyle}
                                        id={`sub_jobs-${idx}`}
                                        key={`sub_jobs-${idx}`}
                                        title={_getTabTitle(sub_job)}
                                    />
                                )
                            })}
                        </Tabs>
                    </Col>
                    <Col lg={11}>
                        {values.sub_jobs && values.sub_jobs.map((sub_job, idx) => {
                            const valuePrefix = `sub_jobs[${idx}]`
                            return (
                                sub_job.job_category && sub_job.job_category.id === 2 &&
                                tabState === `sub_jobs-${idx}` &&
                                <>
                                    <Card>
                                        <Row>
                                            <Col lg={6}>
                                                <FormikSimpleSelect
                                                    name={`${valuePrefix}.status`}
                                                    label='Status'
                                                    items={jobStatuses}
                                                    listenerComponents={[
                                                        {
                                                            componentName: `${valuePrefix}.pebble_details.crew_information.status`,
                                                            componentNewValueCalculator: (a, b, c) => {
                                                                if (b?.id === 19) {//Awaiting Builder 
                                                                    //Filter out completed, applied, canceled, on hold and weeping crew info records and keep only those with dates. 
                                                                    //We will clear these out and reset the status to pending
                                                                    c.allCrewEntries.filter(c => [1, 2, 3].includes(c.phase_type?.id)
                                                                        && (![1, 3, 4, 5, 6].includes(c?.status?.id) || !c?.status) && c?.date).forEach(
                                                                            ci => {
                                                                                return (ci.date = null,
                                                                                    ci.status = jobStatuses.find(s => s.id === 2),
                                                                                    ci.crew = null,
                                                                                    ci.foreman = null)
                                                                            }
                                                                        )
                                                                }
                                                            },
                                                            supportingProps: {
                                                                allCrewEntries: sub_job.pebble_details.crew_information
                                                            }
                                                        },
                                                        {
                                                            componentName: `${valuePrefix}.awaiting_builder_date`,
                                                            componentNewValueCalculator: (a, b, c) => {
                                                                return b?.id !== 19 ?
                                                                    c.awaiting_builder_date = null
                                                                    : c.awaiting_builder_date = moment().format('YYYY-MM-DD')
                                                            },
                                                            supportingProps: {
                                                                awaiting_builder_date: sub_job.awaiting_builder_date
                                                            }
                                                        }
                                                    ]}
                                                />
                                                <FormikDate
                                                    name={`${valuePrefix}.pebble_details.request_date`}
                                                    label='Date of Request'
                                                />
                                                {
                                                    sub_job.status?.id === 19 &&
                                                    <FormikDate
                                                        name={`${valuePrefix}.awaiting_builder_date`}
                                                        label='Awaiting Builder Date'
                                                    />
                                                }
                                                <p className='bp3-label'>Job Type</p>
                                                <p style={{ marginLeft: '.25em' }}>{_getJobTypeNames(values.sub_jobs[idx].job_types)}</p>
                                            </Col>
                                            <Col lg={6}>
                                                <FormikInput
                                                    name={`${valuePrefix}.mmg_pebble_perimeter`}
                                                    placeholder="xxx..."
                                                    label='MMG Pebble Perimeter'
                                                />
                                                <FormikInput
                                                    name={`${valuePrefix}.mmg_ia`}
                                                    placeholder="xxx..."
                                                    label='MMG IA'
                                                />
                                                <FormikInput
                                                    groupStyles={thirdWidthStyle}
                                                    name={`${valuePrefix}.depth_low`}
                                                    label="Depth Low"
                                                    placeholder="xxx..."
                                                />
                                                <FormikInput
                                                    groupStyles={thirdWidthStyle}
                                                    name={`${valuePrefix}.depth_mid`}
                                                    label="Depth Mid"
                                                    placeholder="xxx..."
                                                />
                                                <FormikInput
                                                    groupStyles={thirdWidthStyle}
                                                    name={`${valuePrefix}.depth_high`}
                                                    label="Depth High"
                                                    placeholder="xxx..."
                                                />

                                            </Col>
                                        </Row>
                                        <ColorAdditionsRow
                                            values={sub_job}
                                            valuePrefix={valuePrefix}
                                            isMobile={isMobile}
                                            pebbleColorMaterialTypes={pebbleColorMaterialTypes}
                                            pebbleColors={pebbleColors}
                                            pebbleColorAdditives={pebbleColorAdditives}
                                            poolSections={poolSections}
                                            setFieldValue={setFieldValue}
                                        />
                                        <Divider />
                                        <CrewInformationRow
                                            values={sub_job}
                                            valuePrefix={valuePrefix}
                                            isMobile={isMobile}
                                            employees={employees}
                                            jobStatuses={jobStatuses}
                                            pebblePhases={pebblePhases}
                                            jobOrders={jobOrders}
                                            crews={crewTypes}
                                            slurryPickupOptions={slurryPickupOptions}
                                        />
                                    </Card>
                                </>
                            )
                        }
                        )}
                    </Col>
                </Row>
            </Card>
        }
    </Form>
}